











import { defineComponent, computed } from '@vue/composition-api';

const CommonFavoriteFilterSelector = defineComponent({
  setup(props: any) {
    const list = ['any', 'true', 'false'];
    const display = ['ไม่เลือก', 'ติดดาว', 'ไม่ติดดาว'];
    // ============================== //

    const _value = computed(() => props.value);

    return {
      list,
      display,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return ''; },
    },
    value: {
      type: String,
      default() { return 'any'; },
    },
  },
});

export default CommonFavoriteFilterSelector;
